// extracted by mini-css-extract-plugin
export default {"Container":"Taken_Container__16+yE","table":"Taken_table__5e5Wm","video-icon":"Taken_video-icon__fj9oF","link-upload":"Taken_link-upload__TBZzZ","progress":"Taken_progress__6Cyyu"};